import { IGameState } from '../../../../State/Game/IGameState';
import Game from '../../../../Game';
import { FBTrackingEvent } from '../../../../Utility/Tracking/FBTrackingEvent';
import { PlayerActions } from '../../../../State/Player/PlayerActions';
import { resetEventHandlerData, track } from '../../../../Utility/Tracking/Track';
import { FTUXTrackingEventName } from '../../../../Utility/Tracking/TrackingEvent';

export function trackShownLevelPopup(props: { levelNumber: number }): void {
    const state: IGameState = Game.store.getState();

    switch (props.levelNumber) {
        case 2:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_07_Level2Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_07_Level2Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_07_Level2Play,
                );

                track('stepId', 7);
                track('stepName', FBTrackingEvent.FTUE_07_Level2Play);
                resetEventHandlerData(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 3:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_10_Level3Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_10_Level3Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_10_Level3Play,
                );

                track('stepId', 10);
                track('stepName', FBTrackingEvent.FTUE_10_Level3Play);
                resetEventHandlerData(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 4:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level4PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level4PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level4PreLevelButtonPlay,
                );
            }
            break;
        case 5:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level5PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level5PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level5PreLevelButtonPlay,
                );
            }
            break;
        case 6:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level6PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level6PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level6PreLevelButtonPlay,
                );
            }
            break;
        case 7:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level7PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level7PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level7PreLevelButtonPlay,
                );
            }
            break;
    }
}
